import script from "./WordsGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./WordsGroupList.vue?vue&type=script&setup=true&lang=js"

import "./WordsGroupList.vue?vue&type=style&index=0&id=762432f5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762432f5"]])

export default __exports__